import { useCallback } from 'react';

import { ImageOverlayForm } from 'src/components/ImageOverlayForm';

import { useScoredOverlayData } from '../../../../services/useScoredOverlayData';

export const ImageOverlayTextForm = ({
  className,
  initialData,
  onSubmit,
  onCancel,
  disabled,
  displayPrefix,
  hideActions,
  grayoutTitle,
  onFieldInputChange,
  disableAutoFocus,
  classes,
}) => {
  const { scoredData, onFieldChange, getOutputData } = useScoredOverlayData({
    initialData,
    onFieldInputChange,
  });

  const handleSubmitForm = useCallback(() => {
    const output = getOutputData();
    onSubmit(output);
  }, [onSubmit, getOutputData]);

  return (
    <ImageOverlayForm
      className={className}
      classes={classes}
      data={scoredData}
      onFieldChange={onFieldChange}
      onSubmit={handleSubmitForm}
      onCancel={onCancel}
      disabled={disabled}
      hideActions={hideActions}
      grayoutTitle={grayoutTitle}
      displayPrefix={displayPrefix}
      onFieldInputChange={onFieldInputChange}
      disableAutoFocus={disableAutoFocus}
    />
  );
};
